<template>
  <div>
    <b-row
      align-h="between"
      class="mb-1"
    >
      <b-col
        v-if="estado === 'visualizacao' && (tipoRegra === 'listasuspensa' || tipoRegra === 'caixaselecao')"
        cols="6"
        @click="edit()"
      >
        <span style="margin-right: .4rem;">{{ numeroOpcao + 1 }}.</span>
        <span>{{ value_.descricao }}</span>
        <span
          v-if="value_.outros"
          style="margin-left: 0.5rem;"
        >Complemente: ______________________</span>
      </b-col>
      <b-col
        v-else
        cols="6"
      >
        <!--Lista Suspensa-->
        <div
          v-if="tipoRegra === 'listasuspensa' || tipoRegra === 'caixaselecao'"
          style="display: flex;align-items: center;"
        >
          <span style="margin-right: .4rem;">{{ numeroOpcao + 1 }}.</span>
          <b-input
            v-model="value_.descricao"
            :state="descricaoInvalida !== null ? false:null"
            :class="['numerico-lista-class', {'w-50': value_.outros}]"
            autofocus
            @keydown.enter.native="adicionarRegra"
          />
          <span
            v-if="value_.outros"
            style="margin-left: 0.5rem;"
          >Complemente: ______________________</span>
        </div>
        <!--Texto livre-->
        <b-textarea
          v-else-if="tipoRegra === 'textolivre'"
        />
        <!--Númerico-->
        <b-input
          v-else
          type="number"
          min="0"
          class="numerico-lista-class"
        />
      </b-col>
      <b-col
        cols="auto"
        class="box-servico"
      >
        <div
          v-if="tipoRegra !== 'textolivre'"
          :id="`trigger${idItem}`"
          class="mr-50"
          tabindex="0"
        >
          <feather-icon
            :class="['icon-servico', {'cor-servico': servicoSelecionado}]"
            icon="LinkIcon"
          />
        </div>
        <div style="display: contents;">
          <div>
            <span
              v-if="servicoSelecionado"
              v-b-tooltip.hover
              :title="servicoSelecionado.nome"
              class="limit-character"
            >
              {{ servicoSelecionado.valorAuditar.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }} - {{ servicoSelecionado.nome }}
            </span>
          </div>
          <div
            v-if="tipoRegra === 'listasuspensa' || tipoRegra === 'caixaselecao'"
            class="ml-5"
          >
            <feather-icon
              class="icon-servico"
              icon="XIcon"
              @click="remove()"
            />
          </div>
        </div>
      </b-col>
    </b-row>
    <b-popover
      :target="`trigger${idItem}`"
      triggers="focus"
      placement="auto"
      :show.sync="popoverShow"
      custom-class="popover-servico"
    >
      <div
        slot="title"
        style="text-align: center;"
      >
        <span
          style="vertical-align: sub"
        >Selecione o serviço</span>
        <b-button
          variant="none"
          class="close"
          @click="onClose"
        >
          <span aria-hidden="true">&times;</span>
        </b-button>
      </div>
      <b-row>
        <b-col cols="12">
          <servico-select
            v-model="servicoSelecionado"
            :filtro-por-atividade-tributacao="true"
            :tributacao-id="tributacaoSelecionadaId"
            :atividade-id="atividadeSelecionadaId"
            :clearable="true"
            @input="selecionado"
          />
        </b-col>
      </b-row>
    </b-popover>
  </div>
</template>

<style lang="scss">
.icon-servico {
  height: 22px;
  width: 22px;
}

.icon-servico:hover {
  cursor: pointer;
}

.cor-servico {
  color: #28c76f;
}

.box-servico {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
}

.limit-character {
  display: block;
  width: 460px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.popover-servico {
  max-width: 500px !important;
  width: 500px;
}

.numerico-lista-class:focus {
  border-color: var(--primary);
}
</style>

<script>
export default {
  name: 'ItemServico',
  components: {
    ServicoSelect: () => import('@/shared/components/servico-select/ServicoSelect.vue'),
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    tipoRegra: {
      type: String,
      required: true,
    },
    idItem: {
      type: String,
      required: true,
    },
    numeroOpcao: {
      type: Number,
      default: 1,
    },
    state: {
      type: String,
      required: true,
      default: 'visualizacao',
    },
    tributacaoId: {
      type: Number,
      default: 0,
    },
    atividadeId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      popoverShow: false,
      servicoSelecionado: null,
      value_: null,
      estado: '',
      tributacaoSelecionadaId: 0,
      atividadeSelecionadaId: 0,
      descricaoInvalida: null,
    }
  },
  watch: {
    state(value, oldValue) {
      if (value !== oldValue) {
        this.estado = value
      }
    },
    tributacaoId(value, oldValue) {
      if (value !== oldValue) {
        this.tributacaoSelecionadaId = value
      }
    },
    atividadeId(value, oldValue) {
      if (value !== oldValue) {
        this.atividadeSelecionadaId = value
      }
    },
  },
  created() {
    // eslint-disable-next-line no-underscore-dangle
    this.value_ = this.value
    // eslint-disable-next-line no-underscore-dangle
    this.estado = this.value_.id === 0 && !this.value_.descricao ? 'criacao' : this.state
    // eslint-disable-next-line no-underscore-dangle
    this.servicoSelecionado = this.value_.servico && this.value_.servico.id > 0 ? this.value_.servico : null

    this.tributacaoSelecionadaId = this.tributacaoId
    this.atividadeSelecionadaId = this.atividadeId
  },
  methods: {
    onClose() {
      this.popoverShow = false
    },
    selecionado(value) {
      // eslint-disable-next-line no-underscore-dangle
      this.value_.servico = value
    },
    remove() {
      // eslint-disable-next-line no-underscore-dangle
      this.$emit('remove', this.value_)
    },
    edit() {
      this.atualizarEstado('edicao')
      // eslint-disable-next-line no-underscore-dangle
      this.$emit('mudar-edicao', this.value_)
    },
    atualizarEstado(state) {
      this.estado = state
      // eslint-disable-next-line no-underscore-dangle
      this.value_.state = this.estado
    },
    adicionarRegra() {
      this.$emit('add-regra')
    },
  },
}
</script>
